


















import { Component, Vue } from "vue-property-decorator";
import { Font } from "@/services/fonts/types";

    @Component
export default class FontAlreadyExistsModal extends Vue {
    // local
    localFont = {} as Font;

    // methods
    handleEnter(e: KeyboardEvent) {
        if (e.key === "Enter") this.confirm();
    }

    removeEvent() {
        window.removeEventListener("keydown", this.handleEnter);
    }

    open(item: Font) {
        this.localFont = item;
        this.$bvModal.show("modal-FontAlreadyExists");
        window.addEventListener("keydown", this.handleEnter);
    }

    confirm() {
        this.$bvModal.hide("modal-FontAlreadyExists");
    }
}
